@keyframes _1qkncez1 {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes _1qkncez2 {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes _1qkncez3 {
  from {
    transform: translateX(var(--radix-toast-swipe-end-x));
  }
  to {
    transform: translateX(calc(150px + var(--radix-toast-swipe-end-x)));
    opacity: 0;
  }
}
@layer ui-kit;
@layer ui-kit {
  ._1qkncez0 {
    position: fixed;
    z-index: 2147483647;
    left: 50%;
    bottom: auto;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    margin: 0;
    padding: 0;
    list-style: none;
    top: 0;
    width: 100%;
  }
  ._1qkncez0:not(:empty) {
    margin: 24px 0;
  }
  ._1qkncez4 {
    user-select: auto !important;
    min-height: 48px;
    padding: 12px 24px;
    border-radius: 8px;
    background-color: var(--_1qu8za2z);
    color: var(--_1qu8za2y);
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    will-change: transform, opacity;
  }
  ._1qkncez4[data-swipe="move"] {
    transform: translateX(var(--radix-toast-swipe-move-x));
  }
  ._1qkncez4[data-swipe="cancel"] {
    transform: translateX(0);
    transition: transform 200ms ease-out;
  }
  ._1qkncez4[data-state="open"] {
    animation: _1i9cmca4 200ms ease-out;
  }
  ._1qkncez4[data-state="closed"] {
    animation: _1i9cmca5 200ms ease-out;
  }
  ._1qkncez5 {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: -0.01em;
  }
  ._1qkncez6 {
    font-weight: 400;
    font-size: 12px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    word-break: break-word;
  }
  ._1qkncez7 {
    margin: -9px;
  }
  @media (prefers-reduced-motion: no-preference) {
    ._1qkncez4[data-state="open"] {
      animation: _1qkncez2 200ms ease-out;
    }
    ._1qkncez4[data-swipe="end"] {
      animation: _1qkncez3 200ms ease-out;
    }
  }
  @media screen and (min-width: 768px) {
    ._1qkncez0 {
      top: auto;
      bottom: 0;
      flex-direction: column-reverse;
      width: auto;
    }
    ._1qkncez4[data-state="open"] {
      animation: _1qkncez1 200ms ease-out;
    }
  }
}